module.exports = __webpack_public_path__ + "static/img/index_aboutBg.4b60db1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index_aboutBg.jpg
// module id = 9mqW
// module chunks = 1